define(
	'DC.Facets.Browse.View.Extension'
,   [
		'Facets.Browse.View',
        'Profile.Model',
        'DC.ItemGroupCustomization.Main.SS2Model',
        'FacetsItemsCollectionView',
		'DC.Facets.ItemCell.View.Extension',
        'underscore'
	]
,   function (
		FacetsBrowseView,
        ProfileModel,
        ItemGroupModel,
        FacetsItemsCollectionView,
        DCFacetsItemCellView,
        _
	)
{
	'use strict';

    _.extend(FacetsBrowseView.prototype, {
        beforeShowContent: _.wrap(FacetsBrowseView.prototype.beforeShowContent, function (fn) {
            var promise = jQuery.Deferred();

            // if prices aren't to be shown we take out price related facet
            // and clean up the url
            if (ProfileModel.getInstance().hidePrices()) {
                this.translator = this.translator.cloneWithoutFacetId('onlinecustomerprice');
            }

            var self = this;
            var models = [this.model];
            var categoryModel = this.model.get('category');

            if (categoryModel) {
                models.push(categoryModel);
            }

            jQuery.when
                .apply(null, _.invoke(models, 'fetch', {}))
                .then(function(facetResponse, categoryResponse) {
                    if (categoryModel) {
                        if (categoryResponse[0].errors) {
                            self.application.getLayout().notFound();
                            promise.reject();
                            return promise;
                        }
                        
                        facetResponse = facetResponse[0];
                        
                        // Check if category is for item groups
                        self.checkIfIsItemGroupCategory();
                        // if(SC.CONFIGURATION.itemGroupConfiguration && categoryModel.get('internalid') == SC.CONFIGURATION.itemGroupConfiguration.ccId){
                        if(self.isItemGroupCategory){
                            //lookup for item groups
                            var itemGroupModel = new ItemGroupModel();
                            itemGroupModel.fetch({
                                data: {all: true, categoryId: categoryModel.get('internalid'), itemid: self.getParam('itemid')},
                                async: false,
                            }).done(function(response){
                                if(response && response.itemgroups){
                                    facetResponse.total = Object.keys(response.itemgroups).length;
                                    facetResponse.items = _.map(response.itemgroups, function(item){
                                        item.isItemGroup = true;
                                        return item;
                                    })
                                    self.model.set('total', facetResponse.total);
                                    self.model.set('items', facetResponse.items);
                                }
                            })
                        }//END
                    }

                    if (facetResponse.corrections && facetResponse.corrections.length > 0) {
                        const unaliased_url = self.router.unaliasUrl(null, facetResponse.corrections);
                        promise.reject();

                        if (SC.ENVIRONMENT.jsEnvironment === 'server') {
                            nsglobal.statusCode = 301;
                            nsglobal.location = `/${unaliased_url}`;
                        } else {
                            Backbone.history.navigate(`#${unaliased_url}`, { trigger: true });
                        }
                    } else {
                        self.translator.setLabelsFromFacets(self.model.get('facets') || []);
                        promise.resolve();
                    }
                })
                .fail(function(jqXhr) {
                    promise.reject();

                    if (`${jqXhr.status}` === '404') {
                        self.application.getLayout().notFound();
                    }
                });

            return promise;
        }),

        events: _.extend({}, FacetsBrowseView.prototype.events, {
            'click [data-action="search-itemgroup"]': 'searchItemGroup'
        }),

        searchItemGroup: function(e){
            var value = this.$('[name="itemgroup-search-input"]').val();
            var url = this.appendParamToURL(window.location.href, {key: 'itemid', value: value});
            window.location.href = url;
        },

        appendParamToURL: function(url, param) {
            var u = new URL(url, window.location.origin);
            u.searchParams.set(param.key, param.value);
            return u.toString();
        },

        getParam: function(paramName) {
            var params = new URLSearchParams(window.location.search);
            return params.get(paramName);
        },

        childViews: _.extend({}, FacetsBrowseView.prototype.childViews, {
            'Facets.ItemGroups.Items': function() {
                var self = this;
                var display_option = _.find(this.itemsDisplayOptions, function(option) {
                    return option.id === self.translator.getOptionValue('display');
                });
                if(FacetsItemsCollectionView.__esModule){
                    FacetsItemsCollectionView = FacetsItemsCollectionView.FacetsItemsCollectionView;
                }
                return new FacetsItemsCollectionView({
                    application: this.application,
                    isItemGroupCategory: this.isItemGroupCategory,
                    collection: this.model.get('items').models,
                    viewsPerRow: parseInt(display_option.columns, 10),
                    cellViewTemplate: display_option.template,
                    childView: DCFacetsItemCellView,
                });
            }
        
        }),

        checkIfIsItemGroupCategory: function(){
            var category = this.model.get('category');
            var self = this;
            if(category && category.get('internalid') == SC.CONFIGURATION.itemGroupConfiguration.ccId){
                this.isItemGroupCategory = true;
            }else{
                var breadcrumb = category.get('breadcrumb');
                if(breadcrumb && breadcrumb.length > 1){
                    var parent = _.find(breadcrumb, function(bc){
                        return bc.parenturl === '';
                    });

                    if(parent && parent.internalid == SC.CONFIGURATION.itemGroupConfiguration.ccId){
                        //since parent is item-group so sub-categories are
                        self.isItemGroupCategory = true;
                    }
                }
            }
        },

        getContext: _.wrap(FacetsBrowseView.prototype.getContext, function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            context.isItemGroupCategory = this.isItemGroupCategory;
            if(this.isItemGroupCategory){
                context.itemGroupSearchValue = this.getParam('itemid');
            }
            return context;
        })
    });
	
});
